// import postQuestion from "../actions/questionAction";
import get from 'lodash/get';
import last from 'lodash/last';
import { 
	GET_NEW_QUESTION, 
	API_IN_PROGRESS, 
	UPDATE_QUESTION_ANSWER, 
	GET_NEW_QUESTION_START, 
	GET_QUESTIONS_SUCCESS, 
	SET_CURRENT_BREADCRUMB, 
	GET_REVIEW_SUCCESS, 
	GET_QUOTE_SUCCESS,
	GET_QUESTION_FAILURE,
	GET_DOCUMENT_SUCCESS,
	GET_PLAN_SUCCESS,
	GET_QUOTEREVIEW_SUCCESS,
	GET_SIGNATURE_SUCCESS,
	GET_PAYMENT_SUCCESS,
	SET_ACTION_SUCCESS_MESSAGE,
	SET_ACTION_FAILURE_MESSAGE,
	GET_TIMEOUT_SUCCESS,
	GET_CHALLENGE_SUCCESS,
	GET_RIDERS_SUCCESS,
	GET_COMPLETED_SUCCESS,
	GET_LOGIN_SUCCESS,
	GET_KNOCKOUT_SUCCESS,
	GET_PROCESSING_SUCCESS,
	GET_UNSUBSCRIBED_SUCCESS,
	UPDATE_DATA_SELECTOR_OPTIONS,
	TOGGLE_ESIGN_BUTTON,
	UPDATE_LIST_SECTION,
	GET_PRODUCTS_SUCCESS,
	SET_POPUP_DETAILS,
	GET_INTERVIEW_SUCCESS,
	GET_LAUNCH_SUCCESS,
	SET_MEMBER_DATA_INDEX,
	GET_STATIC_SUCCESS,
	SET_SINGLE_SELECT_FOCUS,
	SET_CSRF_TOKEN,
	MERGE_OFFER_INTO_OTHER_PARAMS,
	SET_QUESTION_STATUS,
	SET_MEMBER_DETAILS_IO_FAILED_SNAPSHOT,
	CLEAR_MEMBER_DETAILS_IO_BLOCKING,
	SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS,
} from '../types';
import HELPER, { getCurrentBreadcrumb } from './helper';
import {
	getCombinedSectionQuestions,
	isVerifyMemberInfoSection,
	isSecondaryAddresseeSection,
	mergePreservedMemberDetailsIoOtherParams,
	preserveMemberDetailsIoSectionErrors,
	sectionIoErrorsFromPayload,
	walkAndPatchAaaMembershipChecksum,
} from '../selector/memberDetails';
import { isMemberDetailsIoStatus } from '../utils/memberDetailsIoStatus';
import { 
	isListQuestion, 
	getListDisplayMode, 
	hasListItems, 
	getAddButtonText, 
	getQuestionStatus,
} from '../actions/listQuestionHelper';

const initialState = {
	breadcrumbs: {
		currentBreadcrumb: {},
		isBreadcrumbLoaded: true,
		breadcrumbList: [],
	},
	isLoading: true,
	currentPageSeqNumber: 0,
	sectionIndex: 0,
	isListAddAction: false,
	activeSubsectionId: '',
	actionMessage: {
		type: '',
		message: '',
	},
	eSign: {
		hasESign: false,
		eSignEnable: false,
	},
	loader: {
		message: 'Just a moment...',
	},
	otherParams: {},
	memberDataIndex: null,
	sections: {
		'testSections': [
			{
				id: '12345',
				answersArray: [],
				errorsArray: [],
				answeredListArray:[],
				otherParams: {},
				errors: {},
				pageDesc: {},
				pageSeqNumber: 0,
				questionList: {},
				leftQuestionList: [],
				layoutRatio: {},
				requiredSchema: {},
				enableContinue: false,
				list: {
					isList: false,
					listDisplay: false,
					hasItems: false,
					addButtonText: 'Add',
					originalQuestions: [],
					questionObj: {},
				},
				listIndex: -1,
				listEditIndex: -1,
				listEditQId: '',
				questionObj: {},
			},
		],
	},
	popupQuestions: [],
	popupDetails: { show: false, question: '' },
	csrfToken: "<default-token>",
	ssoLogin: {
		enable: false
	}
};

const updateBreadcrumbs = (breadcrumbs = {}, payload) => {
	const breadcrumbList = payload.reduce((acc, breadcrumb) => {
		acc.push({
			...breadcrumb,
			id:
				breadcrumb.breadcrumb_id.toLowerCase() ||
				breadcrumb.title.replace(/ /g, '').toLowerCase(),
		});
		return acc;
	}, []);
	return {
		...breadcrumbs,
		breadcrumbList,
		currentBreadcrumb: getCurrentBreadcrumb(breadcrumbList),
		isBreadcrumbLoaded: true,
	}
}

const getLeftAndRightData = (questionItem, skip) => {
	const layout = get(questionItem, 'properties.layout', undefined);
	let leftQuestionList;
	let rightQuestionList;
	if(!skip && layout && layout.value === 'two_columns') {
		const allQuestions = get(questionItem, 'questions', []);
		for (let i=0; i< allQuestions.length; i+=1) {
			const question = allQuestions[i];
			const displayPosition = get(question, 'properties.display_position.value', '');
			if(displayPosition === 'left') {
				leftQuestionList = HELPER.insertReflexiveQuestion(question)
			} else if(displayPosition === 'right') {
				rightQuestionList = HELPER.insertReflexiveQuestion(question);
			}
		}
		return {
			layoutRatio: layout.size,
			leftQuestionList,
			rightQuestionList,
		};
	}
	rightQuestionList = HELPER.insertReflexiveQuestion(questionItem);
	return { layoutRatio: {}, leftQuestionList: [], rightQuestionList }
}

const getFormattedReviewResponse = (questionObj) => {
	const questionsList = [];
	if (questionObj && questionObj.length) {
		questionObj.forEach(ques => {
			if (ques.display_type === 'questions_group') {
				const breadcrumbQuestions = ques.questions;
				// const breadcrumbGroup = { ...ques, questions: [] };
				// questionsList.push(breadcrumbGroup);
				questionsList.push(...[
					{
						...ques,
						isBreadcrumbCard: true,
						questions: [],
					},
					...breadcrumbQuestions,
				]);
			}
			else questionsList.push(ques);
		})
	}
	return questionsList;
}

const isReviewSection = (questionsList) => {
	if (questionsList && questionsList.length) {
		for(let i = 0; i < questionsList.length; i += 1) {
			if(questionsList[i].presentation_type === 'review') return true;
		}
	}
	return false;
}

const walkQuestionsForInvalidStatus = (questions, errorsArray) => {
	let hasInvalidStatus = false;
	if (!Array.isArray(questions)) {
		return { hasInvalidStatus: false };
	}

	questions.forEach((question) => {
		const status = get(question, 'question_status', '');
		const message = get(question, 'question_status_message', '');
		if (status === 'invalid' || message !== '') {
			hasInvalidStatus = true;
			if (question.question_id) {
				errorsArray.push({ question_id: question.question_id, isError: true });
			}
		}
		if (Array.isArray(question.questions) && question.questions.length > 0) {
			const nested = walkQuestionsForInvalidStatus(question.questions, errorsArray);
			hasInvalidStatus = hasInvalidStatus || nested.hasInvalidStatus;
		}
	});

	return { hasInvalidStatus };
};

const collectInvalidQuestionStatusErrors = (leftQuestionList, questionList) => {
	const combinedQuestions = getCombinedSectionQuestions({
		leftQuestionList,
		questionList,
	});
	const isVerify = isVerifyMemberInfoSection(combinedQuestions);
	const isSecondary = isSecondaryAddresseeSection(combinedQuestions);
	if (!isVerify && !isSecondary) {
		return { errorsArray: [], hasInvalidStatus: false };
	}

	const errorsArray = [];
	const { hasInvalidStatus } = walkQuestionsForInvalidStatus(combinedQuestions, errorsArray);

	return { errorsArray, hasInvalidStatus };
};

const buildSectionContinueState = ({
	leftQuestionList,
	questionList,
	requiredSchema,
	answersArray,
	isList,
	listDisplay,
	questionStatus,
	isReview,
}) => {
	const { errorsArray, hasInvalidStatus } = collectInvalidQuestionStatusErrors(
		leftQuestionList,
		questionList,
	);

	if (isReview) {
		return { enableContinue: true, errorsArray: [] };
	}

	const enableContinue = !hasInvalidStatus && HELPER.shouldEnableContinue(
		requiredSchema,
		answersArray,
		errorsArray,
		isList,
		listDisplay,
		questionStatus,
	);

	return { enableContinue, errorsArray };
};

const resetBreadcrumbData = (action) => {
	const { payload, type, params = {} } = action;
	const currentStatus = get(payload, 'other_params.current_status', '');
	const questionObj = get(payload, 'data.questionnarie.questions', {});

	let allQuestions = [];
	allQuestions = get(payload, 'data.questionnarie.questions.questions', []);

	const isReviewStatus = currentStatus === 'review' || currentStatus === 'quotereview';
	if (isReviewStatus) {
		const questionsList = getFormattedReviewResponse(allQuestions);
		allQuestions = questionsList;
	}

	return allQuestions.map((questionItem, index) => {
		const {
			layoutRatio,
			leftQuestionList,
			rightQuestionList,
		} = getLeftAndRightData(questionItem, type === GET_QUOTE_SUCCESS || isReviewStatus);
		const questionList = walkAndPatchAaaMembershipChecksum(rightQuestionList);
		const patchedLeftQuestionList = walkAndPatchAaaMembershipChecksum(leftQuestionList);
		const requiredSchema = HELPER.getRequiredSchema(questionList);
		const isList = isListQuestion(questionList, isReviewStatus);
		const originalQuestions = isList ? HELPER.getOriginalQuestions(questionItem) : [];
		const answersArray = HELPER.buildAnswersArray(questionList, originalQuestions);
		const listDisplay = getListDisplayMode(questionList);
		const questionStatus = getQuestionStatus(questionList);

		// Review Page Related Conditions
		const isReview = isReviewSection(questionList)
		const showReviewContinueButton = false;
		const { enableContinue, errorsArray } = buildSectionContinueState({
			leftQuestionList: patchedLeftQuestionList,
			questionList,
			requiredSchema,
			answersArray,
			isList,
			listDisplay,
			questionStatus,
			isReview: isReviewStatus,
		});
		const memberDetailsIo = get(payload, 'other_params.member_details_io', {});
		return {
			id: HELPER.getRandomId(),
			questionList,
			answeredListQuestion: HELPER.getAnsweredLisQuestionIds(questionList),
			leftQuestionList: patchedLeftQuestionList,
			layoutRatio,
			requiredSchema,
			answersArray,
			errorsArray,
			enableContinue,
			dataSelector: new Map(),
			otherParams: {
				...payload.other_params,
			},
			errors: sectionIoErrorsFromPayload(
				{ leftQuestionList: patchedLeftQuestionList, questionList },
				payload.errors,
				memberDetailsIo,
			),
			pageDesc: {
				...payload.page_desc,
			},
			review: {
				isReview,
				showReviewContinueButton,
			},
			/**
			 * Completed would be false for last section so last section
			 * avoid sending index _modify_flag=1 this issue is caused
			 * when resetBreadcrumbData called when answering reflexive
			 * question in the last section in the
			 * page NAT-1162
			 */
			completed: allQuestions.length - 1 !== index,
			list: {
				isList,
				listDisplay,
				hasItems: hasListItems(rightQuestionList),
				addButtonText: getAddButtonText(rightQuestionList),
				questionObj: questionItem,
				originalQuestions,
			},
			questionObj,
		};
	});
}

const updatedBreadcrumbData = (currentBreadcrumbData = [], action) => {

	const { payload, params, type } = action;
	const questionObj = get(payload, 'data.questionnarie.questions', {});
	const currentStatus =  get(payload, 'other_params.current_status', '');
	const isReview = currentStatus === 'review' || currentStatus === 'quotereview';
    const hasModal = get(payload, 'other_params.has_modal', false);
	const breadcrumbQuestions = last(get(payload, 'data.questionnarie.questions.questions', null));
	const breadcrumbQLength = get(payload, 'data.questionnarie.questions.questions', []).length
	
	// Resets Breadcrumb Data for the following current_status routes
	const resetBreadcrumbRoutes = currentStatus === 'quote' || currentStatus === 'signature' || currentStatus === 'payment';

	/**
	 * If currentBreadcrumbData is an empty array and payload
	 * contains questions, then it means, user has refreshed
	 * the page. In this case all of the
	 * questions need to be copied, other attributes like
	 * required schema, answer
	 * array etc needs to be updated.
	 */
	if (
		isReview ||
		resetBreadcrumbRoutes ||
		currentBreadcrumbData.length === 0 ||
		params.isReflexive ||
		params.validate ||
		params.breadcrumb_nav_flag ||
		params.prev_page_flag ||
		params.reset_sections_data ||
		(breadcrumbQuestions && ('collapse' in breadcrumbQuestions)) ||
		breadcrumbQLength < currentBreadcrumbData.length ||
		hasModal
	) {
		return resetBreadcrumbData(action);
	}

	let questionList = [];
	if (breadcrumbQuestions) {
		let newBreadcrumbData = currentBreadcrumbData;
		const { isReflexive, sectionIndex } = params;
		if (isReflexive) {
			questionList = HELPER.insertReflexiveQuestion(breadcrumbQuestions);
			questionList = walkAndPatchAaaMembershipChecksum(questionList);
			newBreadcrumbData = HELPER.replaceSectionQuestion(currentBreadcrumbData, questionList, sectionIndex);
			return newBreadcrumbData;
		}
		newBreadcrumbData = HELPER.removeDuplicate(currentBreadcrumbData, breadcrumbQuestions);
		const {
			layoutRatio,
			leftQuestionList,
			rightQuestionList,
		} = getLeftAndRightData(breadcrumbQuestions, type === 'GET_QUOTE_SUCCESS');
		const questionList = walkAndPatchAaaMembershipChecksum(rightQuestionList);
		const patchedLeftQuestionList = walkAndPatchAaaMembershipChecksum(leftQuestionList);
		const requiredSchema = HELPER.getRequiredSchema(questionList);
		const listDisplay = getListDisplayMode(questionList);

		let isList = false;
		if (Object.keys(layoutRatio).length === 0) {
			isList = isListQuestion(questionList, isReview);
		}

		const originalQuestions = isList ? HELPER.getOriginalQuestions(breadcrumbQuestions) : [];
		const answersArray = HELPER.buildAnswersArray(questionList, originalQuestions);
		const listError = getQuestionStatus(questionList);
		const { enableContinue, errorsArray } = buildSectionContinueState({
			leftQuestionList: patchedLeftQuestionList,
			questionList,
			requiredSchema,
			answersArray,
			isList,
			listDisplay,
			questionStatus: listError,
			isReview,
		});

		return [
			...newBreadcrumbData,
			{
				id: HELPER.getRandomId(),
				questionList,
				answeredListQuestion: HELPER.getAnsweredLisQuestionIds(questionList),
				leftQuestionList: patchedLeftQuestionList,
				layoutRatio,
				requiredSchema,
				answersArray,
				errorsArray,
				enableContinue,
				otherParams: {
					...payload.other_params,
				},
				errors: sectionIoErrorsFromPayload(
					{ leftQuestionList, questionList },
					payload.errors,
					get(payload, 'other_params.member_details_io', {}),
				),
				pageDesc: {
					...payload.page_desc,
				},
				list: {
					isList,
					listDisplay,
					hasItems: hasListItems(rightQuestionList),
					addButtonText: getAddButtonText(rightQuestionList),
					questionObj: breadcrumbQuestions,
					originalQuestions,
				},
				questionObj,
			},
		]
	}
	return currentBreadcrumbData;
}

const listSectionUpdates = (state = {}, listQIds) => {
	const { errorsArray, answersArray, questionList } = state;
	let _errorsArray = errorsArray.filter((item) => !listQIds.includes(item.question_id))
	return {
		...state,
		errorsArray: _errorsArray,
		answersArray: answersArray.filter((item) => !listQIds.includes(item.question_id)),
		enableContinue: !getQuestionStatus(questionList) && _errorsArray.length === 0,
	}
}

const questionUpdates = (state = {}, action) => {
	const {
		questionId,
		response,
		questionResponse,
		isError,
		isHidden,
		propQuestion,
		reset,
		isControlledInput,
		listParentId,
		listIndex,
		eSign,
		isChangeEvent
	} = action.payload;
	const answersArray = HELPER.addOrReplace(
		state.answersArray,
		{
			question_id: questionId,
			answer: response,
			immediateParent: propQuestion ? propQuestion.immediateParent : '',
			parentId: propQuestion ? propQuestion.parentId : '',
			parentListQuestionId: get(action, 'payload.propQuestion.properties.parent_list_id', ''),
			reset,
			listParentId,
			listIndex,
		},
		'answer',
	);
	const nList = questionId.match(/_\$ureify_/g);
	const skipUpdate = nList && nList.length === 2;
	const questionList = skipUpdate ? state.questionList : 
						HELPER.addOrReplace(state.questionList, { question_id: questionId, is_hidden: isHidden || false }, 'is_hidden');
	const currentStatus = get(action, 'payload.other_params.current_status', '');
	const isList = isListQuestion(state.questionList, currentStatus === 'review');
	const listDisplay = getListDisplayMode(state.questionList);
	const listError = getQuestionStatus(state.questionList);
	const errorsArray = HELPER.addOrReplace(
		state.errorsArray,
		{ question_id: questionId, isError: isError },
		'isError',
	).filter((errorElement) => errorElement && errorElement.isError);

	/**
	 * isError is undefined when the page is reloaded
	 * disable continue if we there's any invalid question
	 */
	 const hasLeftColumn = Array.isArray(state.leftQuestionList) && state.leftQuestionList.length > 0;
	 const combinedQuestionList = hasLeftColumn
		? getCombinedSectionQuestions({
			leftQuestionList: state.leftQuestionList,
			questionList,
		})
		: questionList;
	 let enableContinue = true;
	 if (
		isError === undefined
		&& combinedQuestionList
		&& (
			isVerifyMemberInfoSection(combinedQuestionList)
			|| isSecondaryAddresseeSection(combinedQuestionList)
		)
	) {
		const markInvalidFromTree = (questions) => {
			if (!Array.isArray(questions)) {
				return;
			}
			questions.forEach((question) => {
				const questionStatusMessage = get(question, 'question_status_message', '');
				if (!isChangeEvent && questionStatusMessage !== '') {
					enableContinue = false;
				}
				if (Array.isArray(question.questions) && question.questions.length > 0) {
					markInvalidFromTree(question.questions);
				}
			});
		};
		markInvalidFromTree(combinedQuestionList);
	 }

	const requiredSchema = HELPER.getRequiredSchema(questionList);

	switch (action.type) {
		case UPDATE_QUESTION_ANSWER: {
			const patchQuestionStatusOnField = (question) => {
				if (question.question_id !== questionId) {
					return question;
				}
				if (isChangeEvent || isError !== undefined) {
					const payloadMessage = get(action, 'payload.questionStatusMessage', '');
					const existingMessage = get(question, 'question_status_message', '');
					const patternMessage = get(question, 'validations.pattern.error_message', '');
					const validationMessage = payloadMessage
						|| (!isChangeEvent && isError && existingMessage)
						|| patternMessage
						|| (!patternMessage ? get(question, 'validations.required.error_message', '') : '')
						|| existingMessage;
					return {
						...question,
						question_status: isError ? 'invalid' : 'valid',
						question_status_message: isError ? validationMessage : '',
					};
				}
				return question;
			};
			const updatedQuestionList = HELPER.findAndUpdateResponse(
				questionList,
				questionId,
				response,
				questionResponse,
				isControlledInput,
			).map(patchQuestionStatusOnField);
			const updatedLeftQuestionList = (state.leftQuestionList || []).map(patchQuestionStatusOnField);
			return {
				...state,
				questionList: updatedQuestionList,
				leftQuestionList: updatedLeftQuestionList,
				requiredSchema,
				enableContinue: enableContinue &&
					HELPER.shouldEnableContinue(requiredSchema, answersArray, errorsArray, isList, listDisplay, listError, eSign),
				enableAdd: HELPER.shouldEnableContinue(requiredSchema, answersArray, errorsArray),
				answersArray,
				errorsArray,
			};
		}
		default:
			return state;
	}
}

const getSelectorOptions = ( parentQuestion, currentSelectedOptions, currentOption) => {
	const responseOptions = get(parentQuestion.questions[0], 'response_options', []);
	const currentQuestionId = get(parentQuestion.questions[0], 'question_id', '');
	const sortedOption = [...currentOption].sort(HELPER.getSortOrder('target_question_id'));
	let isPresent = false;
	let dataSelectorOptions = currentSelectedOptions.get(currentQuestionId);
	let selectorIndex = -1;
	let count = 0;
	responseOptions.forEach(response => {
		count = 0;
		const sortedResponse = [...response].sort(HELPER.getSortOrder('target_question_id'));
		for(let index = 0; index < sortedResponse.length; index+=1) {
			if(sortedResponse[index].response.value === sortedOption[index].response.value ){
				count +=1;
			}
		}
		if(count === sortedOption.length){
			isPresent = true;
		}
	})
	if(Array.isArray(dataSelectorOptions)) {
	 	dataSelectorOptions.forEach((dataSelector, index) => {
			count = 0;
			const sortedResponse = [...dataSelector].sort(HELPER.getSortOrder('target_question_id'));;
			if(sortedResponse.length === currentOption.length) {
				for(let i = 0; i < sortedResponse.length; i+=1) {
					if(sortedResponse[i].target_question_id === sortedOption[i].target_question_id ){
						count +=1;
					}
				}
				if(count === sortedOption.length){
					selectorIndex = index;
				}
			}
		});
   	}
   	else {
		dataSelectorOptions = [];
   	}
	if(selectorIndex > -1){
		dataSelectorOptions.splice(selectorIndex, 1);
	}
	if(!isPresent) {
		dataSelectorOptions.push(currentOption);
		currentSelectedOptions.set(currentQuestionId, dataSelectorOptions);
	}
	return currentSelectedOptions;
}

const updateDataSelectorOptions = ( currentSection, action ) => {
   	let currentDataSelector = currentSection.dataSelector;
   	const currentOption = [];
   	const { parentQuestion } = action.payload;
   	const selectorOptions = get(parentQuestion.questions[0], 'selector_options', []);
   	selectorOptions.forEach(option => {
	    const answersArray = HELPER.getAnswersArray(currentSection.answersArray, option.id);
	    if(answersArray.length > 0){
		   currentOption.push({ target_question_id: option.id, response: { value : answersArray[0].answer } });
		}
	});
   	currentDataSelector = getSelectorOptions(parentQuestion, currentDataSelector, currentOption);
   	return { ...currentSection, dataSelector: currentDataSelector };
}


export default function questions(state = initialState, action) {
	let currentBreadcrumb = null;
	let breadcrumbs = {};
	let currentPageSeqNumber = -1;
	let prevSections = [];
	let updatedSectionQuestions;
	let subSectionId;
	let actionMessage = {};
	let bannerInfo='';
	let footerNotes=[];
	let custCareTel='';
	let policyExpiry='';
	let reviseButtonLabel='';
	let footerBanner=null;
	switch (action.type) {
		case GET_NEW_QUESTION_START:
			return {
				...state,
				isLoading: true,
				reload:action.params.reload,
				actionMessage: action.params.actionMessage ?? { type: '', message: '' },
				loadingSection: action.params.sectionIndex,
				isReflexive: action.params.isReflexive,
				validate: action.params.validate,
				isListAddAction: action.params.isListAddAction,
				breadcrumbNavigation: action.params.breadcrumbNavigation,
			}
		case GET_NEW_QUESTION:
		case GET_QUESTIONS_SUCCESS:
		case GET_DOCUMENT_SUCCESS:
			breadcrumbs = updateBreadcrumbs(state.breadcrumbs, get(action, 'payload.breadcrumbs'));
			currentBreadcrumb = breadcrumbs.currentBreadcrumb;
			currentPageSeqNumber = get(action, 'payload.data.questionnarie.page_sequence_number', -1);
			{
				const mergedOtherParams = mergePreservedMemberDetailsIoOtherParams(
					state.otherParams,
					get(action, 'payload.other_params', {}),
				);
				const previousSections = state.sections[currentBreadcrumb.id] || [];
				const nextSections = updatedBreadcrumbData(previousSections, action);
				return {
					...state,
					currentPageSeqNumber,
					breadcrumbs,
					activeSubsectionId: currentBreadcrumb.id,
					otherParams: mergedOtherParams,
					layout: get(action, 'payload.data.questionnarie.questions.properties.layout.value', 'double') === 'one_column' ? 'single' : '',
					sections: {
						...state.sections,
						[currentBreadcrumb.id]: preserveMemberDetailsIoSectionErrors(
							previousSections,
							nextSections,
							mergedOtherParams.member_details_io,
						),
					},
					isLoading: false,
					loader: {
						...state.loader,
						message: get(action, 'payload.other_params.message', 'Just a moment...'),
					},
					popupQuestions: get(action, 'payload.data.popup_questions', []),
					popupDetails: initialState.popupDetails,
					memberDataIndex: null,
				};
			}
		case GET_QUOTE_SUCCESS:
		case GET_PLAN_SUCCESS:
		case GET_QUOTEREVIEW_SUCCESS:
		case GET_SIGNATURE_SUCCESS:
		case GET_PAYMENT_SUCCESS:
		case GET_TIMEOUT_SUCCESS:
		case GET_RIDERS_SUCCESS:
		case GET_COMPLETED_SUCCESS:
		case GET_LOGIN_SUCCESS:
		case GET_KNOCKOUT_SUCCESS:
		case GET_PROCESSING_SUCCESS:
		case GET_UNSUBSCRIBED_SUCCESS:
		case GET_PRODUCTS_SUCCESS:
		case GET_INTERVIEW_SUCCESS:
		case GET_CHALLENGE_SUCCESS:
		case GET_REVIEW_SUCCESS:
		case GET_STATIC_SUCCESS:
		case GET_LAUNCH_SUCCESS:
			bannerInfo=get(action,'payload.data.questionnarie.questions.header','');
			footerNotes=get(action,'payload.data.questionnarie.questions.footer_notes',[]);
			custCareTel=get(action,'payload.data.questionnarie.questions.cust_care_tel','');
			policyExpiry=get(action,'payload.data.questionnarie.questions.policy_expiry_date','');
			reviseButtonLabel=get(action,'payload.data.questionnarie.questions.revise_button_text','');
			footerBanner=get(action,'payload.data.questionnarie.questions.footer_banner',null);
			subSectionId = get(action,'payload.other_params.current_status', '');
			currentPageSeqNumber = get(action, 'payload.data.questionnarie.page_sequence_number', -1);
			{
				const mergedOtherParams = mergePreservedMemberDetailsIoOtherParams(
					state.otherParams,
					get(action, 'payload.other_params', {}),
				);
				const previousSections = state.sections[subSectionId] || [];
				const nextSections = updatedBreadcrumbData(previousSections, action);
				return {
					...state,
					bannerInfo,
					footerNotes,
					custCareTel,
					policyExpiry,
					reviseButtonLabel,
					footerBanner,
					activeSubsectionId: subSectionId,
					currentPageSeqNumber,
					otherParams: mergedOtherParams,
					breadcrumbs,
					sections: {
						...state.sections,
						[subSectionId]: preserveMemberDetailsIoSectionErrors(
							previousSections,
							nextSections,
							mergedOtherParams.member_details_io,
						),
					},
					isLoading: false,
					loader: {
						...state.loader,
						message: get(action, 'payload.other_params.message', 'Just a moment...'),
					},
					popupQuestions: get(action, 'payload.data.popup_questions', []),
					popupDetails: initialState.popupDetails,
				};
			}
		case SET_QUESTION_STATUS: {
			const { activeSubsectionId: subId, sectionIndex: sidx, questionId: qid, questionStatus: qStatus, questionStatusMessage: qMsg } = action.payload;
			prevSections = state.sections;
			const targetSection = prevSections[subId][sidx];
			const patchQuestionStatus = (list = []) => list.map((q) =>
				q.question_id === qid
					? { ...q, question_status: qStatus, question_status_message: qMsg }
					: q,
			);
			const patchedQuestionList = patchQuestionStatus(targetSection.questionList || []);
			const patchedLeftQuestionList = patchQuestionStatus(targetSection.leftQuestionList || []);
			const isInvalid = qStatus === 'invalid';
			const patchedErrors = HELPER.addOrReplace(
				targetSection.errorsArray || [],
				{ question_id: qid, isError: isInvalid },
				'isError',
			).filter((e) => e && e.isError);
			const patchedSchema = HELPER.getRequiredSchema(patchedQuestionList);
			const patchedEnableContinue = HELPER.shouldEnableContinue(
				patchedSchema,
				targetSection.answersArray || [],
				patchedErrors,
				get(targetSection, 'list.isList', false),
				get(targetSection, 'list.listDisplay', false),
				false,
			);
			prevSections[subId][sidx] = {
				...targetSection,
				questionList: patchedQuestionList,
				leftQuestionList: patchedLeftQuestionList,
				errorsArray: patchedErrors,
				enableContinue: patchedEnableContinue,
			};
			return {
				...state,
				sections: { ...state.sections, [subId]: [...prevSections[subId]] },
			};
		}
		case UPDATE_QUESTION_ANSWER:
			prevSections = state.sections;
			updatedSectionQuestions = questionUpdates(state.sections[action.activeSubsectionId][action.payload.sectionIndex], action);
			prevSections[action.activeSubsectionId][action.payload.sectionIndex] = updatedSectionQuestions;
			return {
				...state,
				sections: prevSections,
			};
		case UPDATE_LIST_SECTION:
			prevSections = state.sections;
			updatedSectionQuestions = listSectionUpdates(
				state.sections[action.activeSubsectionId][action.payload.sectionIndex],
				action.payload.listQIds,
			)
			prevSections[action.activeSubsectionId][action.payload.sectionIndex] = updatedSectionQuestions;
			return {
				...state,
				sections: prevSections,
			}
		case UPDATE_DATA_SELECTOR_OPTIONS:
            prevSections = state.sections;
			updatedSectionQuestions = updateDataSelectorOptions(state.sections[action.activeSubsectionId][action.payload.sectionIndex], action)
			return {
				...state,
				sections: prevSections,
			}
		case API_IN_PROGRESS:
			return {
				...state,
				isLoading: true,
				loadingSection: 0,
			}
		case SET_CURRENT_BREADCRUMB:
			return {
				...state,
				breadcrumbs: {
					...state.breadcrumbs,
					currentBreadcrumb: getCurrentBreadcrumb(state.breadcrumbs.breadcrumbList, action.id),
					breadcrumbList: state.breadcrumbs.breadcrumbList.map(
						(breadcrumb) =>  { return { ...breadcrumb, active: (breadcrumb.id === action.id) } }
					),
				},
			};
		case 'SET_LIST_INDEX':
			return {
				...state,
				listIndex: action.index,
			}
		case 'SET_REFLEXIVE_LIST_INDEX':
			return {
				...state,
				listEditIndex: action.index,
				listEditQId: action.id,
			}
		case SET_ACTION_SUCCESS_MESSAGE:
			actionMessage = get(action, 'payload.actionMessage', { type: '', message: '' });
			return {
				...state,
				actionMessage: {
					type: actionMessage.type,
					message: actionMessage.message,
				},
			}
		case GET_QUESTION_FAILURE:
			return {
				...state,
				isLoading: false,
			};
		case SET_ACTION_FAILURE_MESSAGE:
			actionMessage = get(action, 'payload.actionMessage', { type: '', message: '' });
			return {
				...state,
				isLoading: false,
				actionMessage: {
					type: actionMessage.type,
					message: actionMessage.message,
				},
			};	
		case TOGGLE_ESIGN_BUTTON:
			return {
				...state,
				eSign: {
					hasESign: true,
					eSignEnable: action.enable,
				},
			}
		case SET_POPUP_DETAILS:
			return {
				...state,
				popupDetails: action.payload,
			}
		case SET_MEMBER_DATA_INDEX:
			return {
				...state,
				memberDataIndex: action.index,
			}
		case SET_SINGLE_SELECT_FOCUS:
			return {
				...state,
				shouldFocusSingleSelect: action.shouldFocusSingleSelect
			}
		case SET_CSRF_TOKEN:
			return {
				...state,
				csrfToken: action.csrfToken
			}
		case MERGE_OFFER_INTO_OTHER_PARAMS: {
			const offerPatch = get(action, 'payload', {});
			if (!offerPatch || typeof offerPatch !== 'object') {
				return state;
			}
			const otherParams = {
				...state.otherParams,
				...offerPatch,
			};
			return {
				...state,
				otherParams,
			};
		}
		case SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS: {
			if (!action.payload) {
				if (!state.otherParams?.member_details_io) {
					return state;
				}
				const { member_details_io, ...restOtherParams } = state.otherParams;
				return {
					...state,
					otherParams: restOtherParams,
				};
			}
			return {
				...state,
				otherParams: {
					...state.otherParams,
					member_details_io: action.payload,
				},
			};
		}
		case SET_MEMBER_DETAILS_IO_FAILED_SNAPSHOT: {
			const snapshot = action.payload ?? null;
			return {
				...state,
				otherParams: {
					...state.otherParams,
					member_details_io_failed_snapshot: snapshot,
				},
			};
		}
		case CLEAR_MEMBER_DETAILS_IO_BLOCKING: {
			const subId = get(action, 'payload.activeSubsectionId', '');
			const sidx = get(action, 'payload.sectionIndex', -1);
			const memberDetailsIo = get(state, 'otherParams.member_details_io', {});
			const clearedMemberDetailsIo = {
				...memberDetailsIo,
				blocking: false,
			};
			if (isMemberDetailsIoStatus(clearedMemberDetailsIo.uspsValidationStatus, 'blocked')) {
				clearedMemberDetailsIo.uspsValidationStatus = null;
				clearedMemberDetailsIo.uspsMessage = null;
				clearedMemberDetailsIo.uspsValidationTarget = null;
			}
			const nextSections = { ...state.sections };
			if (subId && nextSections[subId] && nextSections[subId][sidx]) {
				nextSections[subId] = [...nextSections[subId]];
				nextSections[subId][sidx] = {
					...nextSections[subId][sidx],
					errors: {},
				};
			}
			return {
				...state,
				otherParams: {
					...state.otherParams,
					member_details_io: clearedMemberDetailsIo,
					member_details_io_failed_snapshot: null,
				},
				actionMessage: {
					type: '',
					message: '',
				},
				sections: nextSections,
			};
		}
		default:
			return state;
	}
}

